module.exports = __webpack_public_path__ + "img/bg20.7c87acc1.png";